import { ReportType } from "@intentsify/types";
import { Endpoints } from "api";
import { useEffect } from "react";
import { useParams } from "react-router";
import { useDownloadFile, useScreen } from "utils";
import { DownloadStatus, useMostRecentDownloadStatus } from "../Download";
import { DownloadReportDefinition } from "./DownloadReport.definition";

const CSV_REPORT_TYPES: ReportType[] = [
  ReportType.CumulativeAdSolutions,
  ReportType.CumulativeIntentFeedBRS,
  ReportType.CumulativeIntentFeedTopics,
  ReportType.CumulativeSitePixelData,
  ReportType.DisplayCumulativeAdSolutions,
  ReportType.DisplayCumulativeIntentFeedBRS,
  ReportType.DisplayAccountLevel,
  ReportType.InnovidAccountLevel,
];

const isReportType = (value: string | undefined): value is ReportType =>
  !!value && Object.values(ReportType).includes(value as ReportType);

const DownloadReport = () => {
  useScreen(DownloadReportDefinition);

  const { reportType, campaignId, correlationId } = useParams<
    "reportType" | "campaignId" | "correlationId"
  >();

  const { download } = useDownloadFile();
  const fileName = `${String(campaignId)}_${String(reportType)}`;
  const downloadingStatus = useMostRecentDownloadStatus(fileName);

  useEffect(() => {
    if (isReportType(reportType) && campaignId && correlationId) {
      download({
        url: Endpoints.Reports.DownloadReport.Get({
          campaignId,
          correlationId,
          reportType,
        }),
        fileName,
        fileExtension: CSV_REPORT_TYPES.includes(reportType) ? "csv" : "pdf",
      });
    }
    // We want it to trigger once only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isReportType(reportType)) {
    throw new Error("404");
  }

  return <DownloadStatus status={downloadingStatus} />;
};

export { DownloadReport };
